import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_BILLS,
  GET_BILL_DETAIL,
  ADD_NEW_BILL,
  UPDATE_BILL,
  DELETE_BILL,
  GET_BILLS_ERRORS,
  GET_EXPORT_BILLS,
  GET_BILLS_FORMATTED_ERRORS,
} from "./actionTypes"
import {
  getBillsSuccess,
  getBillsFail,
  getBillDetailSuccess,
  getBillDetailFail,
  addBillFail,
  addBillSuccess,
  updateBillSuccess,
  updateBillFail,
  deleteBillSuccess,
  deleteBillFail,
  getBillErrorsSuccess,
  getBillErrorsFail,
  getExportBillsSuccess,
  getExportBillsFail,
  getBillFormattedErrorsSuccess,
  getBillFormattedErrorsFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getBills,
  getBillDetails,
  addNewBill,
  updateBill,
  deleteBill,
  getBillErrors,
  getExportBills,
  getBillFormattedErrors,
} from "helpers/backend_helper"

function* fetchBills({ payload }) {
  try {
    const response = yield call(getBills, payload)
    yield put(getBillsSuccess(response))
  } catch (error) {
    yield put(getBillsFail(error))
  }
}

function* fetchBillErrors({ payload }) {
  try {
    const response = yield call(getBillErrors, payload)
    yield put(getBillErrorsSuccess(response))
  } catch (error) {
    yield put(getBillErrorsFail(error))
  }
}

function* fetchBillFormattedErrors({ payload }) {
  try {
    const response = yield call(getBillFormattedErrors, payload)
    yield put(getBillFormattedErrorsSuccess(response))
  } catch (error) {
    yield put(getBillFormattedErrorsFail(error))
  }
}

function* fetchBillDetail({ BillId }) {
  try {
    const response = yield call(getBillDetails, BillId)
    yield put(getBillDetailSuccess(response))
  } catch (error) {
    yield put(getBillDetailFail(error))
  }
}

function* onUpdateBill({ payload: Bill }) {
  try {
    const response = yield call(updateBill, Bill)
    if (response?.success) {
      yield put(updateBillSuccess(response))
    } else {
      yield put(updateBillFail(response))
    }
  } catch (error) {
    yield put(updateBillFail(error))
  }
}

function* onAddNewBill({ payload: Bill }) {
  try {
    const response = yield call(addNewBill, Bill)
    if (response?.success) {
      yield put(addBillSuccess(response))
    } else {
      yield put(addBillFail(response))
    }
  } catch (error) {
    yield put(addBillFail(error))
  }
}

function* onDeleteBill({ payload: Bill }) {
  try {
    const response = yield call(deleteBill, Bill)
    if (response?.success) {
      yield put(deleteBillSuccess(Bill))
    } else {
      yield put(deleteBillFail(response))
    }
  } catch (error) {
    yield put(deleteBillFail(error))
  }
}

function* fetchExportBills({ payload }) {
  try {
    const response = yield call(getExportBills, payload)
    yield put(getExportBillsSuccess(response))
  } catch (error) {
    yield put(getExportBillsFail(error))
  }
}

function* BillSaga() {
  yield takeEvery(GET_BILLS, fetchBills)
  yield takeEvery(GET_BILL_DETAIL, fetchBillDetail)
  yield takeEvery(ADD_NEW_BILL, onAddNewBill)
  yield takeEvery(UPDATE_BILL, onUpdateBill)
  yield takeEvery(DELETE_BILL, onDeleteBill)
  yield takeEvery(GET_BILLS_ERRORS, fetchBillErrors)
  yield takeEvery(GET_BILLS_FORMATTED_ERRORS, fetchBillFormattedErrors)
  yield takeEvery(GET_EXPORT_BILLS, fetchExportBills)
}

export default BillSaga
